import { environment } from '@env/environment';

if (environment.production) {
    if (typeof console !== 'undefined') {
        const consoleMethods = Object.getOwnPropertyNames(console).filter(
            prop => typeof (console as any)[prop] === 'function'
        );

        consoleMethods.forEach(method => {
            (console as any)[method] = () => { };
        });
    }
}